import { useQuery } from '@tanstack/react-query';

import type { SubscriptionBillingDetails } from '~/interfaces/subscriptions';

interface Props {
  enabled: boolean;
  subscriberId: string;
}
interface ReturnProps {
  isLoading: boolean;
  data?: SubscriptionBillingDetails | Record<string, never>;
  refetch: () => void;
}

const useStaticBillingDetails = ({ enabled, subscriberId }: Props): ReturnProps => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['billing-details', subscriberId],
    queryFn: async (): Promise<SubscriptionBillingDetails | Record<string, never>> => {
      const response = await fetch('/billing_details');
      if (!response.ok) {
        throw new Error('Failed to load billing details');
      }
      return response.json();
    },
    enabled,
    refetchOnWindowFocus: false,
    staleTime: Number.POSITIVE_INFINITY,
  });

  return {
    isLoading,
    data,
    refetch,
  };
};
export default useStaticBillingDetails;
